import {
  CountryCode,
  findPhoneNumbersInText,
  NumberFound,
} from "libphonenumber-js";
import { TableCellValue } from "src/requests/table/types";
import { ColumnFormatDict, ValueFormat } from "src/requests/templates/types";

export const isTextLink = (textToCheck: string) =>
  RegExp("^\\w*://").test(textToCheck);

type TextPhoneType = {
  isNumber: boolean;
  number: string;
  formattedNumber: string;
};

export const isDefined = (value: TableCellValue) =>
  value !== null && value !== undefined;

export const isTextPhone = (
  textToCheck: string,
  countries: CountryCode[] = ["CZ", "SK"]
) => {
  if (textToCheck.length < 9) return;

  const foundNumbers: NumberFound[] = [];

  countries.forEach((country) => {
    const res = findPhoneNumbersInText(textToCheck, country);
    if (res.length > 0) foundNumbers.push(res[0]);
  });

  if (!foundNumbers.length) return;

  // eslint-disable-next-line consistent-return
  return {
    isNumber: true,
    number: foundNumbers[0].number.number as string,
    formattedNumber: foundNumbers[0].number.formatInternational(),
  };
};

export const isTextEmail = (textToCheck: string) =>
  RegExp(
    /^(([^<>()[\]\\.,;:\s@/"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  ).test(textToCheck.trim());

const AGR_DATE_REGEX =
  /\[date\(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z\)::\d*\]/;

const AGR_DATE_REGEX_G =
  /\[date\((\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z)\)::(\d*)\]/g;

export const isAgrStringDate = (stringToTest: string) =>
  RegExp(AGR_DATE_REGEX).test(stringToTest);

const getValueFormat = (itemId: string, columnsFormat?: ColumnFormatDict) => {
  if (!itemId || !columnsFormat) return undefined;

  return columnsFormat[Number(itemId)]?.value;
};

export const getFormattedAgrDateString = (
  textToFormat: string,
  collumnsFormat: ColumnFormatDict | undefined,
  formatter: (text: string, format?: ValueFormat) => string
) => {
  const results = [...textToFormat.matchAll(AGR_DATE_REGEX_G)];

  const formattedDates = results.map((result) => {
    const [_, date, itemId] = result;

    const adjustTimezone = (prevDate: string) => {
      // date is in CET (timezone), but we want it to be in UTC for rest of code so we need to adjust by - 2 hours

      const dateObj = new Date(prevDate);
      const utcDate = new Date(
        dateObj.getTime() + dateObj.getTimezoneOffset() * 60000
      );

      return utcDate.toISOString();
    };

    const format = getValueFormat(itemId, collumnsFormat);

    return formatter(adjustTimezone(date), format);
  });

  return formattedDates.reduce(
    (acc, curr) => acc.replace(AGR_DATE_REGEX, curr),
    textToFormat
  );
};
